(function() {

    /* globals $, L, i18n */

    'use strict';

    if(!document.querySelector('#map')) {
        return;
    }

    var markerSizes = {
        10: 25,
        11: 25,
        12: 25,
        13: 15,
        14: 15,
        15: 4,
        16: 6,
        17: 7,
        18: 12
    };

    var map = L.map('map', { maxZoom: 18, minZoom: 10 }),
        container = map.getContainer(),
        markers = L.layerGroup().addTo(map),
        isExtendedMode = container.dataset.mode === 'extended';

    /* Legend */

    if(isExtendedMode) {

        var legend = L.control({ position: 'bottomright' });

        legend.onAdd = function() {

            this._div = L.DomUtil.create('div', 'info legend');

            this._div.innerHTML += '<div><i class="circle" style="background:#585858"></i> ' + i18n.t('map.legend.multiple') + '</div>';
            this._div.innerHTML += '<div><i class="circle" style="background:#2E2EFE"></i> ' + i18n.t('map.legend.full_ownership') + '</div>';
            this._div.innerHTML += '<div><i class="circle" style="background:#04B404"></i> ' + i18n.t('map.legend.partial_ownership') + '</div>';
            this._div.innerHTML += '<div><i class="circle" style="background:#f39c12"></i> ' + i18n.t('map.legend.current_property') + '</div>';
            this._div.innerHTML += '<div><i class="circle" style="background:#ff0000"></i> ' + i18n.t('map.legend.missing_ownership') + '</div>';

            return this._div;

        };

        legend.addTo(map);

    }

    function popUpHandler(e) {

        var marker = e.target,
            html;

        html = '<br><small><a href="' + marker.propertyData.path + '" target="_blank">' + i18n.t('map.actions.edit') + '</a></small>';

        marker.bindPopup(marker.propertyData.street + html)
            .openPopup();

    }

    function isSelectedProperty(map, coordinates) {

        if(map.propertyCoordinates === null) {
            return false;
        }

        return (coordinates[0] === map.propertyCoordinates[0] && coordinates[1] === map.propertyCoordinates[1]);

    }

    function getMapData(map) {

        var bounds = map.getBounds(),
            southWest = bounds.getSouthWest(),
            northEast = bounds.getNorthEast(),
            zoomLevel = map.getZoom(),
            minLat, maxLat, minLon, maxLon;

        minLat = Math.min(northEast.lat, southWest.lat);
        maxLat = Math.max(northEast.lat, southWest.lat);
        minLon = Math.min(northEast.lng, southWest.lng);
        maxLon = Math.max(northEast.lng, southWest.lng);

        $.ajax({
            url: window.location.href,
            type: 'GET',
            dataType: 'json',
            data: {
                'min_lat': minLat,
                'max_lat': maxLat,
                'min_lon': minLon,
                'max_lon': maxLon,
                'zoom_level': zoomLevel
            },
            success: function(locations) {

                markers.clearLayers();

                var radius = markerSizes[zoomLevel],
                    interactive = (zoomLevel >= 15);

                locations.forEach(function(location) {

                    var coordinates = location.coordinates,
                        options = { radius: radius, interactive: interactive },
                        marker;

                    options.color = '#585858'; // grey

                    if(!!location.propertyData && isExtendedMode) {

                        if(location.propertyData.ownershipType === 'partial_ownership') {
                            options.color = '#04B404'; // green
                        } else if (location.propertyData.ownershipType === 'full_ownership') {
                            options.color = '#2E2EFE'; // blue
                        } else {
                            options.color = '#ff0000'; // red
                        }

                    }

                    if(isSelectedProperty(map, coordinates)) {
                        options.color = '#f39c12'; // orange
                    }

                    marker = L.circleMarker(coordinates, options);
                    marker.propertyData = location.propertyData;

                    if(isExtendedMode) {
                        marker.on('click', popUpHandler);
                    }

                    markers.addLayer(marker);

                });

            }
        });

    }

    // Update Map if filter changed
    $('body').on('ajax:complete', 'form.filter', function() {
        getMapData(map);
    });

    map.on('moveend', function() {
        getMapData(this);
    });

    if(container.hasAttribute('data-property-latitude') && container.hasAttribute('data-property-longitude')) {

        var propertyCoordinates = [
            parseFloat(container.getAttribute('data-property-latitude')),
            parseFloat(container.getAttribute('data-property-longitude'))
        ];

        map.setView(propertyCoordinates, 18);
        map.propertyCoordinates = propertyCoordinates;

    } else {

        var defaultCoordinates = [
            parseFloat(container.getAttribute('data-default-latitude')),
            parseFloat(container.getAttribute('data-default-longitude'))
        ];

        if(isNaN(defaultCoordinates[0]) || isNaN(defaultCoordinates[1])) {
            alert('DEFAULT_LATITUDE and/or DEFAULT_LONGITUDE environment variables are unset')
            return;
        }

        map.setView(defaultCoordinates, 13);
        map.propertyCoordinates = null;

    }

    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy;&nbsp;<a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

})();